import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import EventPage from "./pages/EventPage";
import PicnicEventPage from "./pages/PicnicEventPage";
import OnamEventPage from "./pages/OnamEventPage";
import DiwaliEventPage from "./pages/DiwaliEventPage";
import GenericEventPage from "./pages/GenericEventPage";
import GalleryPage from "./pages/GalleryPage";
import SponsorsPage from "./pages/SponsorsPage";
import SponsorshipEventPage from "./pages/SponsorshipEventPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import PromotionsPage from "./pages/PromotionsPage";
import CharityPage from "./pages/CharityPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

// Member Pages
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import MemberDashboard from "./pages/MemberDashboard";
import MyTicketsPage from "./pages/MyTicketsPage";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminSponsors from "./pages/admin/AdminSponsors";
import AdminContent from "./pages/admin/AdminContent";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminAboutImages from "./pages/admin/AdminAboutImages";
import AdminPromos from "./pages/admin/AdminPromos";
import AdminMembers from "./pages/admin/AdminMembers";
import AdminBackup from "./pages/admin/AdminBackup";
import AdminSitePages from "./pages/admin/AdminSitePages";
import AdminTicketInventory from "./pages/admin/AdminTicketInventory";

// Layout
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            {/* Vishu 2026 - Hidden per user request, but route kept for existing ticket holders */}
            <Route path="/vishu-2026" element={<EventPage />} />
            <Route path="/ramanavami-2026" element={<GenericEventPage />} />
            {/* Picnic 2026 - Disabled */}
            <Route path="/picnic-2026" element={<PicnicEventPage />} />
            {/* Onam 2026 - Disabled */}
            <Route path="/onam-2026" element={<OnamEventPage />} />
            {/* Diwali 2026 - Main active event */}
            <Route path="/diwali-2026" element={<DiwaliEventPage />} />
            <Route path="/karkidaka-vavu-bali-2026" element={<GenericEventPage />} />
            <Route path="/onam-2026" element={<GenericEventPage />} />
            <Route path="/vidhyarambam-2026" element={<GenericEventPage />} />
            <Route path="/mandalakalam-2026" element={<GenericEventPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            <Route path="/sponsorship/:eventSlug" element={<SponsorshipEventPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/promotions" element={<PromotionsPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            
            {/* Charity Routes */}
            <Route path="/charity/:charitySlug" element={<CharityPage />} />
            {/* Legacy charity routes for backwards compatibility */}
            <Route path="/charity-food-drive" element={<CharityPage />} />
            <Route path="/charity-blood-donation" element={<CharityPage />} />
            
            {/* Privacy Policy */}
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            
            {/* Member Routes */}
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/member" element={<MemberDashboard />} />
            <Route path="/my-tickets" element={<MyTicketsPage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="members" element={<AdminMembers />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="about-images" element={<AdminAboutImages />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="promos" element={<AdminPromos />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="site-pages" element={<AdminSitePages />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="backup" element={<AdminBackup />} />
            <Route path="inventory" element={<AdminTicketInventory />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
